import { render, staticRenderFns } from "./comList.vue?vue&type=template&id=296744f5&scoped=true"
import script from "./comList.vue?vue&type=script&lang=js"
export * from "./comList.vue?vue&type=script&lang=js"
import style0 from "./comList.vue?vue&type=style&index=0&id=296744f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296744f5",
  null
  
)

export default component.exports